/* eslint-disable camelcase */
export default {
   'THH01_P': {
      'tapseg': '1A',
      'tapcode': 'thh01',
      'segNameShort': 'Top Tier',
      'segName': '2020 Top Tier (1A) Tapestry Households (Esri)',
      'median_age': 47.3,
      'avg_hh_size': 2.84,
      'diversity_idx': 37.9,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment1.pdf',
      'Description': 'The residents of the wealthiest Tapestry market, <i>Top Tier</i>, earn more than three times the US household income. They have the purchasing power to indulge any choice and follow their heart\'s desire.'
   },
   'THH02_P': {
      'tapseg': '1B',
      'tapcode': 'thh02',
      'segNameShort': 'Professional Pride',
      'segName': '2020 Professional Pride (1B) Tapestry Households (Esri)',
      'median_age': 40.8,
      'avg_hh_size': 3.13,
      'diversity_idx': 44.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment2.pdf',
      'Description': '<i>Professional Pride</i> consumers are well-educated career professionals that have prospered through the Great Recession. To maintain their upscale suburban lifestyles, these goal-oriented couples work, often commuting far and working long hours.'
   },
   'THH03_P': {
      'tapseg': '1C',
      'tapcode': 'thh03',
      'segNameShort': 'Boomburbs',
      'segName': '2020 Boomburbs (1C) Tapestry Households (Esri)',
      'median_age': 34,
      'avg_hh_size': 3.25,
      'diversity_idx': 63.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment3.pdf',
      'Description': 'This is the new growth market, with a profile similar to the original: young professionals with families that have opted to trade up to the newest housing in the suburbs. The original <i>Boomburbs</i> neighborhoods began growing in the 1990s and continued through the peak of the housing boom.'
   },
   'THH04_P': {
      'tapseg': '1D',
      'tapcode': 'thh04',
      'segNameShort': 'Savvy Suburbanites',
      'segName': '2020 Savvy Suburbanites (1D) Tapestry Households (Esri)',
      'median_age': 45.1,
      'avg_hh_size': 2.85,
      'diversity_idx': 36.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment4.pdf',
      'Description': '<i>Savvy Suburbanites</i> residents are well educated, well read, and well capitalized. Families include empty nesters and empty nester wannabes, who still have adult children at home.'
   },
   'THH05_P': {
      'tapseg': '1E',
      'tapcode': 'thh05',
      'segNameShort': 'Exurbanites',
      'segName': '2020 Exurbanites (1E) Tapestry Households (Esri)',
      'median_age': 51,
      'avg_hh_size': 2.5,
      'diversity_idx': 35.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment5.pdf',
      'Description': '<i>Exurbanites</i> residents are now approaching retirement but showing few signs of slowing down. They are active in their communities, generous in their donations, and seasoned travelers.'
   },
   'THH06_P': {
      'tapseg': '2A',
      'tapcode': 'thh06',
      'segNameShort': 'Urban Chic',
      'segName': '2020 Urban Chic (2A) Tapestry Households (Esri)',
      'median_age': 43.3,
      'avg_hh_size': 2.39,
      'diversity_idx': 48.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment6.pdf',
      'Description': '<i>Urban Chic</i> residents are professionals that live a sophisticated, exclusive lifestyle. Half of all households are occupied by married-couple families, and about 30% are singles.'
   },
   'THH07_P': {
      'tapseg': '2B',
      'tapcode': 'thh07',
      'segNameShort': 'Pleasantville',
      'segName': '2020 Pleasantville (2B) Tapestry Households (Esri)',
      'median_age': 42.6,
      'avg_hh_size': 2.88,
      'diversity_idx': 61,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment7.pdf',
      'Description': 'Prosperous domesticity best describes the settled denizens of <i>Pleasantville</i>. Situated principally in older housing in suburban areas in the Northeast (especially in New York and New Jersey) and secondarily in the West (especially in California), these slightly older couples move less than any other market.'
   },
   'THH08_P': {
      'tapseg': '2C',
      'tapcode': 'thh08',
      'segNameShort': 'Pacific Heights',
      'segName': '2020 Pacific Heights (2C) Tapestry Households (Esri)',
      'median_age': 42.7,
      'avg_hh_size': 3.17,
      'diversity_idx': 75,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment8.pdf',
      'Description': '<i>Pacific Heights</i> is one of the smaller markets (with less than 1% of households), composed of upscale neighborhoods in the urban periphery of metropolitan areas, along the Pacific Coast in California, in Hawaii, and in the Northeast.'
   },
   'THH09_P': {
      'tapseg': '2d',
      'tapcode': 'thh09',
      'segNameShort': 'Enterprising Professionals',
      'segName': '2019 Enterprising Professionals (2D) Tapestry Households (Esri)',
      'median_age': 35.3,
      'avg_hh_size': 2.48,
      'diversity_idx': 73,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment9.pdf',
      'Description': 'Our segment is up-and-coming, so we frequently change jobs as we climb the ladder. We rent housing, which often consists of condos, town homes, or apartments. We tend to live in lower-density neighborhoods of large metro areas.'
   },
   'THH10_P': {
      'tapseg': '3A',
      'tapcode': 'thh10',
      'segNameShort': 'Laptops and Lattes',
      'segName': '2020 Laptops and Lattes (3A) Tapestry Households (Esri)',
      'median_age': 37.4,
      'avg_hh_size': 1.87,
      'diversity_idx': 50.3,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment10.pdf',
      'Description': '<i>Laptops and Lattes</i> residents are predominantly single, well-educated professionals in business, finance, legal, computer, and entertainment occupations. They are affluent and partial to city living—and its amenities.'
   },
   'THH11_P': {
      'tapseg': '3B',
      'tapcode': 'thh11',
      'segNameShort': 'Metro Renters',
      'segName': '2020 Metro Renters (3B) Tapestry Households (Esri)',
      'median_age': 32.5,
      'avg_hh_size': 1.67,
      'diversity_idx': 61.9,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment11.pdf',
      'Description': 'Residents in this highly mobile and educated market live alone or with a roommate in older apartment buildings and condos located in the urban core of the city. This is one of the fastest-growing segments; the popularity of urban life continues to increase for consumers in their late twenties and thirties.'
   },
   'THH12_P': {
      'tapseg': '3C',
      'tapcode': 'thh12',
      'segNameShort': 'Trendsetters',
      'segName': '2020 Trendsetters (3C) Tapestry Households (Esri)',
      'median_age': 36.3,
      'avg_hh_size': 2.12,
      'diversity_idx': 76.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment12.pdf',
      'Description': 'Armed with the motto "you\'re only young once," <i>Trendsetters</i> residents live life to its full potential. These educated young singles aren\'t ready to settle down; they tend to not own homes or vehicles and choose to spend their disposable income on upscale city living and entertainment.'
   },
   'THH13_P': {
      'tapseg': '4A',
      'tapcode': 'thh13',
      'segNameShort': 'Workday Drive',
      'segName': '2020 Workday Drive (4A) Tapestry Households (Esri)',
      'median_age': 37,
      'avg_hh_size': 2.97,
      'diversity_idx': 50.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment13.pdf',
      'Description': '<i>Workday Drive</i> is an affluent, family-oriented market with a country flavor. Residents are partial to new housing away from the bustle of the city but close enough to commute to professional job centers.'
   },
   'THH14_P': {
      'tapseg': '4B',
      'tapcode': 'thh14',
      'segNameShort': 'Home Improvement',
      'segName': '2020 Home Improvement (4B) Tapestry Households (Esri)',
      'median_age': 37.7,
      'avg_hh_size': 2.88,
      'diversity_idx': 65.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment14.pdf',
      'Description': 'Married-couple families occupy well over half of these suburban households. Most <i>Home Improvement</i> residences are single-family homes that are owner occupied, with only one-fifth of the households occupied by renters.'
   },
   'THH15_P': {
      'tapseg': '4C',
      'tapcode': 'thh15',
      'segNameShort': 'Middleburg',
      'segName': '2020 Middleburg (4C) Tapestry Households (Esri)',
      'median_age': 36.1,
      'avg_hh_size': 2.75,
      'diversity_idx': 48.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment15.pdf',
      'Description': '<i>Middleburg</i> neighborhoods transformed from the easy pace of country living to semirural subdivisions in the last decade when the housing boom stretched beyond large metropolitan cities. Residents are traditional, family-oriented consumers.'
   },
   'THH16_P': {
      'tapseg': '5A',
      'tapcode': 'thh16',
      'segNameShort': 'Comfortable Empty Nesters',
      'segName': '2020 Comfortable Empty Nesters (5A) Tapestry Households (Esri)',
      'median_age': 48,
      'avg_hh_size': 2.52,
      'diversity_idx': 33,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment16.pdf',
      'Description': 'Residents in this large, growing segment are older, with nearly half of all householders aged 55 or older; many still live in the suburbs where they grew up. Most are professionals working in government, health care, or manufacturing.'
   },
   'THH17_P': {
      'tapseg': '5B',
      'tapcode': 'thh17',
      'segNameShort': 'In Style',
      'segName': '2020 In Style (5B) Tapestry Households (Esri)',
      'median_age': 42,
      'avg_hh_size': 2.35,
      'diversity_idx': 39.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment17.pdf',
      'Description': '<i>In Style</i> denizens embrace an urbane lifestyle that includes support of the arts, travel, and extensive reading. They are connected and make full use of the advantages of mobile devices.'
   },
   'THH18_P': {
      'tapseg': '5C',
      'tapcode': 'thh18',
      'segNameShort': 'Parks and Rec',
      'segName': '2020 Parks and Rec (5C) Tapestry Households (Esri)',
      'median_age': 49,
      'avg_hh_size': 2.51,
      'diversity_idx': 50.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment18.pdf',
      'Description': 'These suburbanites have achieved the dream of homeownership. They have purchased homes that are within their means.'
   },
   'THH19_P': {
      'tapseg': '5D',
      'tapcode': 'thh19',
      'segNameShort': 'Rustbelt Traditions',
      'segName': '2020 Rustbelt Traditions (5D) Tapestry Households (Esri)',
      'median_age': 39,
      'avg_hh_size': 2.47,
      'diversity_idx': 46.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment19.pdf',
      'Description': 'The backbone of older industrial cities in states surrounding the Great Lakes, <i>Rustbelt Traditions</i> residents are a mix of married-couple families and singles living in older developments of single-family homes.'
   },
   'THH20_P': {
      'tapseg': '5E',
      'tapcode': 'thh20',
      'segNameShort': 'Midlife Constants',
      'segName': '2020 Midlife Constants (5E) Tapestry Households (Esri)',
      'median_age': 47,
      'avg_hh_size': 2.31,
      'diversity_idx': 36.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment20.pdf',
      'Description': '<i>Midlife Constants</i> residents are seniors, at or approaching retirement, with below average labor force participation and above average net worth. Although located in predominantly metropolitan areas, they live outside the central cities in smaller communities.'
   },
   'THH21_P': {
      'tapseg': '6A',
      'tapcode': 'thh21',
      'segNameShort': 'Green Acres',
      'segName': '2020 Green Acres (6A) Tapestry Households (Esri)',
      'median_age': 43.9,
      'avg_hh_size': 2.7,
      'diversity_idx': 26,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment21.pdf',
      'Description': 'The <i>Green Acres</i> lifestyle features country living and self-reliance. Avid do-it-yourselfers, they maintain and remodel their homes with all the necessary power tools to accomplish the jobs.'
   },
   'THH22_P': {
      'tapseg': '6B',
      'tapcode': 'thh22',
      'segNameShort': 'Salt of the Earth',
      'segName': '2020 Salt of the Earth (6B) Tapestry Households (Esri)',
      'median_age': 44.1,
      'avg_hh_size': 2.59,
      'diversity_idx': 19.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment22.pdf',
      'Description': '<i>Salt of the Earth</i> residents are entrenched in their traditional, rural lifestyles. Citizens here are older, and many have grown children that have moved away.'
   },
   'THH23_P': {
      'tapseg': '6C',
      'tapcode': 'thh23',
      'segNameShort': 'The Great Outdoors',
      'segName': '2020 The Great Outdoors (6C) Tapestry Households (Esri)',
      'median_age': 47.4,
      'avg_hh_size': 2.44,
      'diversity_idx': 35.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment23.pdf',
      'Description': 'These neighborhoods are found in pastoral settings throughout the United States. Consumers are educated empty nesters living an active but modest lifestyle.'
   },
   'THH24_P': {
      'tapseg': '6D',
      'tapcode': 'thh24',
      'segNameShort': 'Prairie Living',
      'segName': '2020 Prairie Living (6D) Tapestry Households (Esri)',
      'median_age': 44.4,
      'avg_hh_size': 2.51,
      'diversity_idx': 24.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment24.pdf',
      'Description': '<i>Prairie Living</i> is the most rural market of Tapestry Segmentation, comprising about 1.2 percent of households, located mainly in the Midwest, with a predominance of self-employed farmers.'
   },
   'THH25_P': {
      'tapseg': '6E',
      'tapcode': 'thh25',
      'segNameShort': 'Rural Resort Dwellers',
      'segName': '2020 Rural Resort Dwellers (6E) Tapestry Households (Esri)',
      'median_age': 54.1,
      'avg_hh_size': 2.22,
      'diversity_idx': 23.4,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment25.pdf',
      'Description': 'Although the Great Recession forced many owners of second homes to sell, <i>Rural Resort Dwellers</i> residents remain an active market, just a bit smaller. These communities are centered in resort areas, many in the Midwest, where the change in seasons supports a variety of outdoor activities.'
   },
   'THH26_P': {
      'tapseg': '6F',
      'tapcode': 'thh26',
      'segNameShort': 'Heartland Communities',
      'segName': '2020 Heartland Communities (6F) Tapestry Households (Esri)',
      'median_age': 42.3,
      'avg_hh_size': 2.39,
      'diversity_idx': 31.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment26.pdf',
      'Description': 'Well settled and close-knit, <i>Heartland Communities</i> residents are semiretired and live in semirural areas. These older householders are primarily homeowners, and many have paid off their mortgages.'
   },
   'THH27_P': {
      'tapseg': '7A',
      'tapcode': 'thh27',
      'segNameShort': 'Up and Coming Families',
      'segName': '2020 Up and Coming Families (7A) Tapestry Households (Esri)',
      'median_age': 31.4,
      'avg_hh_size': 3.12,
      'diversity_idx': 73.9,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment27.pdf',
      'Description': '<i>Up and Coming Families</i> is a market in transition—residents are younger and more mobile than the previous generation. They are ambitious—working hard to get ahead and willing to take some risks to achieve their goals.'
   },
   'THH28_P': {
      'tapseg': '7B',
      'tapcode': 'thh28',
      'segNameShort': 'Urban Villages',
      'segName': '2020 Urban Villages (7B) Tapestry Households (Esri)',
      'median_age': 34,
      'avg_hh_size': 3.78,
      'diversity_idx': 86,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment28.pdf',
      'Description': '<i>Urban Villages</i> residents are multigenerational and multilingual. Trendy and fashion conscious, they are risk-takers. However, these consumers focus on their children and maintain gardens.'
   },
   'THH29_P': {
      'tapseg': '7C',
      'tapcode': 'thh29',
      'segNameShort': 'Urban Edge Families',
      'segName': '2020 Urban Edge Families (7C) Tapestry Households (Esri)',
      'median_age': 32.5,
      'avg_hh_size': 3.19,
      'diversity_idx': 84.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment29.pdf',
      'Description': 'Located throughout the South and West, most <i>Urban Edge Families</i> residents own their own homes—primarily single-family housing out of the city where housing is more affordable.'
   },
   'THH30_P': {
      'tapseg': '7D',
      'tapcode': 'thh30',
      'segNameShort': 'Forging Opportunity',
      'segName': '2020 Forging Opportunity (7D) Tapestry Households (Esri)',
      'median_age': 28.9,
      'avg_hh_size': 3.62,
      'diversity_idx': 80.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment30.pdf',
      'Description': 'Family is central within these communities, bringing rich traditions to these neighborhoods in the urban outskirts. Dominating this market are younger families with children or single-parent households with multiple generations living under the same roof.'
   },
   'THH31_P': {
      'tapseg': '7E',
      'tapcode': 'thh31',
      'segNameShort': 'Primary Spread',
      'segName': '2020 Primary Spread (7E) Tapestry Households (Esri)',
      'median_age': 27.4,
      'avg_hh_size': 3.98,
      'diversity_idx': 84.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment31.pdf',
      'Description': '<i>Farm to Table</i> is a small but distinctive market located almost entirely in the West (primarily in California and Washington). These neighborhoods are home to young families with children and, frequently, multiple generations living in single-family homes.'
   },
   'THH32_P': {
      'tapseg': '7F',
      'tapcode': 'thh32',
      'segNameShort': 'Southwestern Families',
      'segName': '2020 Southwestern Families (7F) Tapestry Households (Esri)',
      'median_age': 34.6,
      'avg_hh_size': 3.2,
      'diversity_idx': 65,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment32.pdf',
      'Description': 'Residents in these neighborhoods are young families primarily located in the Southwest. Children are the center of households that are composed mainly of married couples with children and single-parent families.'
   },
   'THH33_P': {
      'tapseg': '8A',
      'tapcode': 'thh33',
      'segNameShort': 'City Lights',
      'segName': '2020 City Lights (8A) Tapestry Households (Esri)',
      'median_age': 39.3,
      'avg_hh_size': 2.59,
      'diversity_idx': 75.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment33.pdf',
      'Description': '<i>City Lights</i> is a densely populated urban market. The wide-ranging demographic characteristics of residents mirror their passion for social welfare and equal opportunity.'
   },
   'THH34_P': {
      'tapseg': '8B',
      'tapcode': 'thh34',
      'segNameShort': 'Emerald City',
      'segName': '2020 Emerald City (8B) Tapestry Households (Esri)',
      'median_age': 37.4,
      'avg_hh_size': 2.06,
      'diversity_idx': 50.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment34.pdf',
      'Description': '<i>Emerald City\'s</i> denizens live in lower-density neighborhoods of urban areas throughout the country. Young and mobile, they are more likely to rent. Half have a college degree and a professional occupation.'
   },
   'THH35_P': {
      'tapseg': '8C',
      'tapcode': 'thh35',
      'segNameShort': 'Bright Young Professionals',
      'segName': '2020 Bright Young Professionals (8C) Tapestry Households (Esri)',
      'median_age': 33,
      'avg_hh_size': 2.41,
      'diversity_idx': 67.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment35.pdf',
      'Description': '<i>Bright Young Professionals</i> is a large market, primarily located in urban outskirts of large metropolitan areas. These communities are home to young, educated, working professionals. More than one out of three householders are under the age of 35.'
   },
   'THH36_P': {
      'tapseg': '8D',
      'tapcode': 'thh36',
      'segNameShort': 'Downtown Melting Pot',
      'segName': '2020 Downtown Melting Pot (8D) Tapestry Households (Esri)',
      'median_age': 37.7,
      'avg_hh_size': 2.93,
      'diversity_idx': 77.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment36.pdf',
      'Description': '<i>Downtown Melting Pot</i> is a smaller, settled market, composed of much older neighborhoods located in cities in the Middle Atlantic division (mainly New York) or on the Pacific Coast.'
   },
   'THH37_P': {
      'tapseg': '8E',
      'tapcode': 'thh37',
      'segNameShort': 'Front Porches',
      'segName': '2020 Front Porches (8E) Tapestry Households (Esri)',
      'median_age': 34.9,
      'avg_hh_size': 2.57,
      'diversity_idx': 72.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment37.pdf',
      'Description': '<i>Front Porches</i> neighborhoods are a blend of household types with more young families with children and more single households than average. More than half of householders are renters, and many of the homes are older townhomes or duplexes.'
   },
   'THH38_P': {
      'tapseg': '8F',
      'tapcode': 'thh38',
      'segNameShort': 'Old and Newcomers',
      'segName': '2020 Old and Newcomers (8F) Tapestry Households (Esri)',
      'median_age': 39.4,
      'avg_hh_size': 2.12,
      'diversity_idx': 52.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment38.pdf',
      'Description': 'This market features singles\' lifestyles on a budget. The focus is more on convenience than consumerism, economy over acquisition. <i>Old and Newcomers</i> is composed of neighborhoods in transition, populated by renters who are just beginning their careers or retiring.'
   },
   'THH39_P': {
      'tapseg': '8G',
      'tapcode': 'thh39',
      'segNameShort': 'Hometown Heritage',
      'segName': '2020 Hometown Heritage (8G) Tapestry Households (Esri)',
      'median_age': 32.4,
      'avg_hh_size': 2.66,
      'diversity_idx': 75.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment39.pdf',
      'Description': '<i>Hometown Heritage</i> neighborhoods are in urbanized areas within central cities with older housing, located mainly in the Midwest and South. This slightly smaller market is primarily a family market with married couples (with and without children) and single parents.'
   },
   'THH40_P': {
      'tapseg': '9A',
      'tapcode': 'thh40',
      'segNameShort': 'Silver and Gold',
      'segName': '2020 Silver and Gold (9A) Tapestry Households (Esri)',
      'median_age': 63.2,
      'avg_hh_size': 2.03,
      'diversity_idx': 24.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment40.pdf',
      'Description': 'Almost the oldest senior market, <i>Silver and Gold</i> is the most affluent senior market. The affluence of <i>Silver and Gold</i> residents has afforded the opportunity to retire to sunnier climates that feature exclusive communities and vacation homes.'
   },
   'THH41_P': {
      'tapseg': '9B',
      'tapcode': 'thh41',
      'segNameShort': 'Golden Years',
      'segName': '2020 Golden Years (9B) Tapestry Households (Esri)',
      'median_age': 52.3,
      'avg_hh_size': 2.06,
      'diversity_idx': 43.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment41.pdf',
      'Description': 'Independent, active seniors nearing the end of their careers or already in retirement best describes <i>Golden Years</i> residents. This market is primarily singles living alone or empty nesters.'
   },
   'THH42_P': {
      'tapseg': '9C',
      'tapcode': 'thh42',
      'segNameShort': 'The Elders',
      'segName': '2020 The Elders (9C) Tapestry Households (Esri)',
      'median_age': 72.3,
      'avg_hh_size': 1.68,
      'diversity_idx': 22.4,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment42.pdf',
      'Description': 'With a median age of 72.3 years, this is the oldest market of Tapestry Segmentation. <i>The Elders</i> residents favor communities designed for senior or assisted living, primarily in warmer climates with seasonal populations.'
   },
   'THH43_P': {
      'tapseg': '9D',
      'tapcode': 'thh43',
      'segNameShort': 'Senior Escapes',
      'segName': '2020 Senior Escapes (9D) Tapestry Households (Esri)',
      'median_age': 54.6,
      'avg_hh_size': 2.2,
      'diversity_idx': 44.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment43.pdf',
      'Description': '<i>Senior Escapes</i> neighborhoods are heavily concentrated in the warmer states of Florida, California, and Arizona. These areas are highly seasonal, yet homes are owner occupied. Many homes began as seasonal getaways and now serve as primary residences.'
   },
   'THH44_P': {
      'tapseg': '9E',
      'tapcode': 'thh44',
      'segNameShort': 'Retirement Communities',
      'segName': '2020 Retirement Communities (9E) Tapestry Households (Esri)',
      'median_age': 53.9,
      'avg_hh_size': 1.88,
      'diversity_idx': 49.4,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment44.pdf',
      'Description': '<i>Retirement Communities</i> neighborhoods are evenly distributed across the country. They combine single-family homes and independent living with apartments, assisted living, and continuous care nursing facilities.'
   },
   'THH45_P': {
      'tapseg': '9F',
      'tapcode': 'thh45',
      'segNameShort': 'Social Security Set',
      'segName': '2020 Social Security Set (9F) Tapestry Households (Esri)',
      'median_age': 45.6,
      'avg_hh_size': 1.73,
      'diversity_idx': 75.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment45.pdf',
      'Description': '<i>Social Security Set</i> is an older market located in metropolitan cities across the country. One-fourth of householders are aged 65 or older and dependent on low, fixed incomes, primarily Social Security.'
   },
   'THH46_P': {
      'tapseg': '10A',
      'tapcode': 'thh46',
      'segNameShort': 'Southern Satellites',
      'segName': '2020 Southern Satellites (10A) Tapestry Households (Esri)',
      'median_age': 40.3,
      'avg_hh_size': 2.67,
      'diversity_idx': 40.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment46.pdf',
      'Description': '<i>Southern Satellites</i> is the second-largest market found in rural settlements but within metropolitan areas located primarily in the South. This market is typically slightly older, settled married-couple families who own their homes.'
   },
   'THH47_P': {
      'tapseg': '10B',
      'tapcode': 'thh47',
      'segNameShort': 'Rooted Rural',
      'segName': '2020 Rooted Rural (10B) Tapestry Households (Esri)',
      'median_age': 45.2,
      'avg_hh_size': 2.48,
      'diversity_idx': 29.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment47.pdf',
      'Description': '<i>Rooted Rural</i> is heavily concentrated in the Appalachian mountain range as well as in Texas and Arkansas. Employment in the forestry industry is common, and <i>Rooted Rural</i> residents live in many of the heavily forested regions of the country.'
   },
   'THH48_P': {
      'tapseg': '10C',
      'tapcode': 'thh48',
      'segNameShort': 'Economic BedRock',
      'segName': '2020 Economic BedRock (10C) Tapestry Households (Esri)',
      'median_age': 41.3,
      'avg_hh_size': 2.54,
      'diversity_idx': 43.3,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment48.pdf',
      'Description': 'Close to one in five employed residents works in mining, oil and gas extraction, or quarrying industries. <i>Economic BedRock</i> is a very rural, primarily Southern market.'
   },
   'THH49_P': {
      'tapseg': '10D',
      'tapcode': 'thh49',
      'segNameShort': 'Down the Road',
      'segName': '2020 Down the Road (10D) Tapestry Households (Esri)',
      'median_age': 35,
      'avg_hh_size': 2.76,
      'diversity_idx': 71.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment49.pdf',
      'Description': '<i>Down the Road</i> is a mix of low-density, semirural neighborhoods in large metropolitan areas; half are located in the South with the rest primarily in the West and Midwest. Almost half of householders live in mobile homes; more than two-fifths live in single-family homes.'
   },
   'THH50_P': {
      'tapseg': '10E',
      'tapcode': 'thh50',
      'segNameShort': 'Rural Bypasses',
      'segName': '2020 Rural Bypasses (10E) Tapestry Households (Esri)',
      'median_age': 40.4,
      'avg_hh_size': 2.55,
      'diversity_idx': 60.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment50.pdf',
      'Description': 'Open space, undeveloped land, and farmland characterize <i>Rural Bypasses</i>. These families live within small towns along country back roads and enjoy the open air in these sparsely populated neighborhoods.'
   },
   'THH51_P': {
      'tapseg': '11A',
      'tapcode': 'thh51',
      'segNameShort': 'City Strivers',
      'segName': '2020 City Strivers (11A) Tapestry Households (Esri)',
      'median_age': 35.3,
      'avg_hh_size': 2.78,
      'diversity_idx': 63.9,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment51.pdf',
      'Description': 'These high-density city neighborhoods are characterized by a relatively young, foreign-born population who have embraced the American lifestyle, yet retained their cultural integrity. To support their lifestyle, <i>City Strivers</i> residents commute long distances to find work in the service, health care, or retail industry.'
   },
   'THH52_P': {
      'tapseg': '11B',
      'tapcode': 'thh52',
      'segNameShort': 'Young and Restless',
      'segName': '2020 Young and Restless (11B) Tapestry Households (Esri)',
      'median_age': 29.8,
      'avg_hh_size': 2.04,
      'diversity_idx': 77.4,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment52.pdf',
      'Description': 'Gen Y comes of age: Well-educated young workers, some of whom are still completing their education, are employed in professional/technical occupations as well as sales and office/administrative support roles.'
   },
   'THH53_P': {
      'tapseg': '11C',
      'tapcode': 'thh53',
      'segNameShort': 'Metro Fusion',
      'segName': '2020 Metro Fusion (11C) Tapestry Households (Esri)',
      'median_age': 29.3,
      'avg_hh_size': 2.65,
      'diversity_idx': 84.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment53.pdf',
      'Description': '<i>Metro Fusion</i> is a young market. Many residents do not speak English fluently and have moved into their homes recently. They are highly mobile, and renters occupy over three-quarters of homes.'
   },
   'THH54_P': {
      'tapseg': '11D',
      'tapcode': 'thh54',
      'segNameShort': 'Set to Impress',
      'segName': '2020 Set to Impress (11D) Tapestry Households (Esri)',
      'median_age': 33.9,
      'avg_hh_size': 2.12,
      'diversity_idx': 67.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment54.pdf',
      'Description': '<i>Set to Impress</i> is depicted by medium to large multiunit apartments with lower than average rents. These apartments are often nestled in neighborhoods with other businesses or single-family housing.'
   },
   'THH55_P': {
      'tapseg': '11E',
      'tapcode': 'thh55',
      'segNameShort': 'City Commons',
      'segName': '2020 City Commons (11E) Tapestry Households (Esri)',
      'median_age': 28.5,
      'avg_hh_size': 2.67,
      'diversity_idx': 50.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment55.pdf',
      'Description': 'This Tapestry Segment is one of the youngest markets. It is primarily composed of single-parent and single-person households living within large metro cities located primarily in the eastern half of the US.'
   },
   'THH56_P': {
      'tapseg': '12A',
      'tapcode': 'thh56',
      'segNameShort': 'Family Foundations',
      'segName': '2020 Family Foundations (12A) Tapestry Households (Esri)',
      'median_age': 39.6,
      'avg_hh_size': 2.71,
      'diversity_idx': 43.5,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment56.pdf',
      'Description': 'Family and faith are the cornerstones of life in these communities. Older children, still living at home and working toward financial independence, are common within these households.'
   },
   'THH57_P': {
      'tapseg': '12B',
      'tapcode': 'thh57',
      'segNameShort': 'Traditional Living',
      'segName': '2020 Traditional Living (12B) Tapestry Households (Esri)',
      'median_age': 35.5,
      'avg_hh_size': 2.51,
      'diversity_idx': 55.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment57.pdf',
      'Description': 'Residents in this segment live primarily in low-density, settled neighborhoods in the Midwest. The households are a mix of married-couple families and singles.'
   },
   'THH58_P': {
      'tapseg': '12C',
      'tapcode': 'thh58',
      'segNameShort': 'Small Town Sincerity',
      'segName': '2020 Small Town Sincerity (12C) Tapestry Households (Esri)',
      'median_age': 40.8,
      'avg_hh_size': 2.26,
      'diversity_idx': 51,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment58.pdf',
      'Description': '<i>Small Town Sincerity</i> includes young families and senior householders that are bound by community ties. The lifestyle is down-to-earth and semirural, with television for entertainment and news, and emphasis on convenience for both young parents and senior citizens.'
   },
   'THH59_P': {
      'tapseg': '12D',
      'tapcode': 'thh59',
      'segNameShort': 'Modest Income Homes',
      'segName': '2020 Modest Income Homes (12D) Tapestry Households (Esri)',
      'median_age': 37,
      'avg_hh_size': 2.56,
      'diversity_idx': 34,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment59.pdf',
      'Description': 'Families in this urban segment may be nontraditional; however, their religious faith and family values guide their modest lifestyles. Many residents are primary caregivers to their elderly family members.'
   },
   'THH60_P': {
      'tapseg': '13A',
      'tapcode': 'thh60',
      'segNameShort': 'Diverse Convergence',
      'segName': '2020 Diverse Convergence (13A) Tapestry Households (Esri)',
      'median_age': 32.8,
      'avg_hh_size': 3.07,
      'diversity_idx': 88.7,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment60.pdf',
      'Description': '<i>Diverse Convergence</i> neighborhoods are a rich blend of cultures found in densely populated urban and suburban areas, almost entirely in the Middle Atlantic (especially in New York and New Jersey) or in California. Almost 40% of residents are foreign-born; nearly one in four households is linguistically isolated.'
   },
   'THH61_P': {
      'tapseg': '13B',
      'tapcode': 'thh61',
      'segNameShort': 'Family Extensions',
      'segName': '2020 Family Extensions (13B) Tapestry Households (Esri)',
      'median_age': 28.3,
      'avg_hh_size': 4.12,
      'diversity_idx': 85.4,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment61.pdf',
      'Description': '<i>Family Extensions is a family-oriented market distinguished by multigenerational households. Their spending reflects their children—baby food and furniture or children\'s apparel—and convenience—fast food and family restaurants.'
   },
   'THH62_P': {
      'tapseg': '13C',
      'tapcode': 'thh62',
      'segNameShort': 'NeWest Residents',
      'segName': '2020 NeWest Residents (13C) Tapestry Households (Esri)',
      'median_age': 27.3,
      'avg_hh_size': 3.35,
      'diversity_idx': 87.3,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment62.pdf',
      'Description': '<i>Newest Residents</i> denizens are new to America and their careers, often with new, young families. Many are new to the English language; nearly one-third of households are linguistically isolated.'
   },
   'THH63_P': {
      'tapseg': '13D',
      'tapcode': 'thh63',
      'segNameShort': 'Fresh Ambitions',
      'segName': '2020 Fresh Ambitions (13D) Tapestry Households (Esri)',
      'median_age': 28.6,
      'avg_hh_size': 3.17,
      'diversity_idx': 90.6,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment63.pdf',
      'Description': 'These young families, many of whom are recent immigrants, focus their life and work around their children. <i>Fresh Ambitions</i> residents have overcome the language barrier and earned a high school diploma. They work overtime in service, in skilled and unskilled occupations, and spend what they have on their children.'
   },
   'THH64_P': {
      'tapseg': '13E',
      'tapcode': 'thh64',
      'segNameShort': 'High Rise Renters',
      'segName': '2020 High Rise Renters (13E) Tapestry Households (Esri)',
      'median_age': 32.2,
      'avg_hh_size': 2.82,
      'diversity_idx': 90.2,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment64.pdf',
      'Description': 'High Rise Renters residents are located predominantly in the Northeast, especially in New York City. This market is near the top for density, diversity, presence of adult children, linguistic isolation, and foreign-born population. They travel far for employment, usually in service jobs, and depend on public transportation.'
   },
   'THH65_P': {
      'tapseg': '14A',
      'tapcode': 'thh65',
      'segNameShort': 'Military Proximity',
      'segName': '2020 Military Proximity (14A) Tapestry Households (Esri)',
      'median_age': 22.6,
      'avg_hh_size': 3.38,
      'diversity_idx': 68.1,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment65.pdf',
      'Description': 'One of the youngest markets, <i>Military Proximity</i> is composed of married-couple families just beginning parenthood with an average household size of 3.38. The armed forces are the common bond for these consumers.'
   },
   'THH66_P': {
      'tapseg': '14B',
      'tapcode': 'thh66',
      'segNameShort': 'College Towns',
      'segName': '2020 College Towns (14B) Tapestry Households (Esri)',
      'median_age': 24.5,
      'avg_hh_size': 2.14,
      'diversity_idx': 56.3,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment66.pdf',
      'Description': 'About half the residents of <i>College Towns</i> are enrolled in college, while the rest work for a college or the services that support it. Students have busy schedules but make time between studying and part-time jobs for socializing and sports.'
   },
   'THH67_P': {
      'tapseg': '14C',
      'tapcode': 'thh67',
      'segNameShort': 'Dorms to Diplomas',
      'segName': '2020 Dorms to Diplomas (14C) Tapestry Households (Esri)',
      'median_age': 21.6,
      'avg_hh_size': 2.22,
      'diversity_idx': 55.8,
      'url': 'https://downloads.esri.com/esri_content_doc/dbl/us/tapestry/segment67.pdf',
      'Description': 'On their own for the first time, <i>Dorms to Diplomas</i> residents are just learning about finance and cooking. Frozen dinners and fast food are common options. Shopping trips are sporadic, and preferences for products are still being established.'
   },
   'THH68_P': {
      'tapseg': '15',
      'tapcode': 'thh68',
      'segNameShort': 'Unclassified',
      'segName': '2019 Unclassified (15) Tapestry Households (Esri)',
      'median_age': '',
      'avg_hh_size': '',
      'diversity_idx': '',
      'url': '',
      'Description': ''
   }
};
